import React from 'react'
import { BadgePercent, Gift, TicketCheck, Wallet } from "lucide-react";
import { Badge } from '../../ui/badge';
import { Separator } from '../../ui/separator';

const availableRewards = [
  {
    id: '1',
    name: 'Discount 10%',
    icon: BadgePercent,
    status: 'Active',
    validity: '16/04/2025 - 30/04/2025',
    tncUrl: '/#',
  },
  {
    id: '2',
    name: 'Discount RM5.00',
    icon: BadgePercent,
    status: 'Active',
    validity: '16/04/2025 - 30/04/2025',
    tncUrl: '/#',
  },
  {
    id: '3',
    name: 'Cashback RM3.00',
    icon: Wallet,
    status: 'Upcoming',
    validity: '16/04/2025 - 30/04/2025',
    tncUrl: '/#',
  },
  {
    id: '4',
    name: 'Stamp 1 quantity',
    icon: Gift,
    status: 'Upcoming',
    validity: '16/04/2025 - 30/04/2025',
    tncUrl: '/#',
  },
  {
    id: '5',
    name: 'Point 300',
    icon: TicketCheck,
    status: 'Inactive',
    validity: '16/04/2025 - 30/04/2025',
    tncUrl: '/#',
  },
];

const getStatusColor = (status: string) => {
  switch (status) {
    case 'Active':
      return 'bg-green-100 text-green-800 hover:bg-green-100 hover:text-green-800';
    case 'Upcoming':
      return 'bg-blue-100 text-blue-800 hover:bg-blue-100 hover:text-blue-800';
    case 'Inactive':
      return 'bg-red-100 text-red-800 hover:bg-red-100 hover:text-red-800';
    default:
      return '';
  }
}

const AvailableRewards: React.FC = () => {
  return (
    <>
      <p className='text-start text-base font-semibold'>
        Available rewards
      </p>

      <div className='flex flex-col gap-y-4'>
        {availableRewards.map((reward) => (
          <>
            <div key={reward.id} className='flex items-center gap-x-4'>
              <reward.icon className='h-6 w-6 text-primary' />
              <div className='flex flex-col gap-2'>
                <div className='flex flex-row gap-4'>
                  <p className='text-base font-light'>{reward.name}</p>
                  <Badge className={`px-4 text-xs font-medium ${getStatusColor(reward.status)}`}>
                    {reward.status}
                  </Badge>
                </div>

                <div className='flex flex-row gap-4'>
                  <p className='text-sm font-light text-gray-500'>Validity: {reward.validity}</p>
                  <a className='text-sm font-light text-blue-600' href={reward.tncUrl}>T&C</a>
                </div>
              </div>
            </div>

            <Separator />
          </>

        ))}
      </div>
    </>
  )
}

export default AvailableRewards